export default __webpack_public_path__ + "static/media/map-mobile.9ecc0e3c.webp";